import { useDispatch, useSelector } from "react-redux";
import { StoreRootState } from "@/store";
import { useLogoutMutation } from "@/store/apis/auth.api";
import { logout } from "@/store/slices/auth.slice";
import { Roles } from "@/utils/types";
import { useLocation, useNavigate } from "react-router-dom";
import { personaHomePage } from "@/utils/constants";

export default function Header() {
    const location = useLocation()
    const navigate = useNavigate();
    const { userInfo, user } = useSelector((state: StoreRootState) => state.auth);
    const [logoutAction] = useLogoutMutation();
    const dispatch = useDispatch();

    return (
        <header className="header">
            <img src="/assets/logo_with_name.png" alt="Doha Drug Store Logo" onClick={() => {
                if (user) navigate(personaHomePage[user.role])
            }} />
            {userInfo?.email && !location.pathname.includes('/course/') && <div className="user-info" data-aos="fade-down">
                <i className="fa-solid fa-user"></i>
                <p>{userInfo?.email}</p>
                <i className="fa-solid fa-right-from-bracket" onClick={(e) => {
                    e.stopPropagation();
                    const target = user.role === Roles.Coordinator ? 'coordinators' : 'admins';
                    logoutAction({ target }).finally(() => {
                        dispatch(logout());
                    });


                }}></i>
            </div>}
        </header>)
}